import React from 'react';
import { BookIcon, StoreIcon } from 'lucide-react';
import { useUserRole } from '../../context/UserRoleContext';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { usePlatform } from '../../context/PlatformContext';
interface UserRoleToggleProps {
  isReader: boolean;
  toggleUserRole: () => void;
}
const UserRoleToggle: React.FC<UserRoleToggleProps> = ({
  isReader,
  toggleUserRole
}) => {
  const dk = useDarkClasses();
  const {
    isAfterTide
  } = usePlatform();
  return <button onClick={toggleUserRole} className={`flex items-center px-2.5 py-1.5 rounded-full border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:border-transparent
        ${isAfterTide ? 'focus-visible:ring-[#e2b04a]' : isReader ? 'focus-visible:ring-indigo-500' : 'focus-visible:ring-purple-500'}
        ${isAfterTide ? 'border-[#16213e] hover:border-[#e2b04a]/30' : dk.isDark ? 'border-gray-600 hover:bg-gray-700' : 'border-gray-300 hover:bg-gray-100'}`} aria-label={`Switch to ${isReader ? 'vendor' : 'reader'} mode`} data-id="element-3930" data-mp="1bnrxo591u5ng">
      <div className="flex items-center space-x-1" data-id="element-3931" data-mp="3vmgd0tejldcv">
        <div className={`rounded-full p-1 transition-colors ${isReader ? isAfterTide ? 'bg-[#e2b04a]/20 text-[#e2b04a]' : dk.isDark ? 'bg-indigo-900/60 text-indigo-400' : 'bg-indigo-100 text-indigo-500' : isAfterTide ? 'bg-[#16213e] text-[#a0a0b0]' : dk.isDark ? 'bg-gray-700 text-gray-500' : 'bg-gray-100 text-gray-400'}`} data-id="element-3932" data-mp="3vo9meggjibok">
          <BookIcon className="h-4 w-4" data-id="element-3933" data-mp="ifwtv9366d4t" />
        </div>
        <div className={`rounded-full p-1 transition-colors ${!isReader ? isAfterTide ? 'bg-[#c77dba]/20 text-[#c77dba]' : dk.isDark ? 'bg-purple-900/60 text-purple-400' : 'bg-purple-100 text-purple-600' : isAfterTide ? 'bg-[#16213e] text-[#a0a0b0]' : dk.isDark ? 'bg-gray-700 text-gray-500' : 'bg-gray-100 text-gray-400'}`} data-id="element-3934" data-mp="idalj78gftlj">
          <StoreIcon className="h-4 w-4" data-id="element-3935" data-mp="2u68u6f0w6k5x" />
        </div>
      </div>
      <span className={`ml-2 text-xs font-medium ${isAfterTide ? 'text-[#f5f0e8]' : dk.isDark ? 'text-gray-200' : 'text-gray-700'}`} data-id="element-3936" data-mp="zoz9rowyo0r9">
        {isReader ? 'Reader' : 'Vendor'}
      </span>
    </button>;
};
export default UserRoleToggle;